// extracted by mini-css-extract-plugin
export default {"container":"LoginWrapper_container__lg4js","logoWrapper":"LoginWrapper_logoWrapper__tepD4","formWrapper":"LoginWrapper_formWrapper__QQld8"};